var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"content-wrapper"}),(_vm.$route.matched.length && !_vm.$route.meta.hideGlobalFloatingLayer)?_c('right-floating-layer',{ref:"rightFL"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }